"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_history_1 = require("prosemirror-history");
var behavior_1 = require("@syl-editor/core-utilities/dist/lib/basic/keymap/behavior");
require("codemirror/lib/codemirror.css");
var createSylCardDOM = function () {
    var div = document.createElement('div');
    div.setAttribute('__syl_tag', 'true');
    div.setAttribute('contenteditable', 'false');
    div.setAttribute('draggable', 'true');
    div.innerHTML = '<templ style="display: none"></templ><mask></mask>';
    return div;
};
exports.createSylCardDOM = createSylCardDOM;
var fixCodeString = function (code) {
    return code
        .replace(/&nbsp;/g, ' ')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};
exports.fixCodeString = fixCodeString;
var cmRedo = function (view) {
    prosemirror_history_1.redo(view.state, view.dispatch);
    view.focus();
};
exports.cmRedo = cmRedo;
var cmUndo = function (view) {
    behavior_1.undo(view.state, view.dispatch);
    view.focus();
};
exports.cmUndo = cmUndo;
var DEFAULT_LANGUAGE = 'javascript';
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
var transformToShow = function (iLanguage) {
    var language = iLanguage
        .split(/[-,]/)
        .filter(Boolean)
        .join('');
    if (language === 'js') {
        language = 'javascript';
    }
    return language;
};
exports.transformToShow = transformToShow;
// 光标在首位时删除空的代码块
var removeEmptyCodeBlock = function (view, code) {
    var state = view.state, dispatch = view.dispatch;
    var selection = state.selection;
    if (code.getValue().trim() || !selection.empty || selection.$from !== selection.$to) {
        return false;
    }
    var $pos = selection.$from;
    var parent = $pos.node();
    // 确定光标在首位
    if ($pos.start() !== $pos.pos || !parent.type.spec.code) {
        return false;
    }
    var type = !$pos.node(-1) && $pos.node(-1) !== state.schema.nodes.doc ? $pos.node(-1).type : state.schema.nodes.paragraph;
    var tr = state.tr.setNodeMarkup($pos.before(), type);
    dispatch(tr);
    return true;
};
exports.removeEmptyCodeBlock = removeEmptyCodeBlock;
//# sourceMappingURL=utils.js.map